import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "utils/axios";
import EditOeuvreModal from "../components/modal/EditOeuvreModal";
import { useAuth } from "../hooks/auth";
import Layout from "../components/layout/Layout";
import SEO from "components/SEO/SEO";
import moment from "moment";
import ReactGA from "react-ga";
import { getImageByLink } from "utils/link";

function getCurrentURL() {
  return window.location.href;
}

const BlockLink = ({ title, content }) => {
  return (
    <div className="flex flex-col justify-between overflow-hidden text-left transition-shadow duration-200 bg-white rounded shadow-xl group hover:shadow-2xl">
      <div className="p-5">
        <p className="mb-2 text-sm font-medium border-b pb-1.5">{title}</p>
        <p className="text-sm leading-5 text-gray-900">
          <ul className="list-disc ml-4 space-y-4">
            {Array.isArray(content) &&
              content?.map((item, index) => (
                <li key={index} className="border-b pb-2">
                  <a
                    className="text-indigo-600 hover:text-pblue cursor-pointer"
                    href={`${"/oppdb/redirect/?"}${"&redirect_url="}${item}`}
                    target="_blank"
                  >
                    <img
                      alt={`${getImageByLink(item)}`}
                      src={`${"/oppdb/images/assets/logos/"}${getImageByLink(
                        item
                      )}${".png"}`}
                      className="h-10"
                    />
                  </a>
                </li>
              ))}
          </ul>
        </p>
      </div>
      <div className="w-full h-1 ml-auto duration-300 origin-left transform scale-x-0 bg-deep-purple-accent-400 group-hover:scale-x-100" />
    </div>
  );
};

const Block = ({ title, content }) => {
  return (
    <div className="flex flex-col justify-between overflow-hidden text-left transition-shadow duration-200 bg-white rounded shadow-xl group hover:shadow-2xl">
      <div className="p-5">
        <p className="mb-2 text-sm font-medium border-b pb-1.5">{title}</p>
        <p className="text-sm leading-5 text-gray-900">{content}</p>
      </div>
      <div className="w-full h-1 ml-auto duration-300 origin-left transform scale-x-0 bg-deep-purple-accent-400 group-hover:scale-x-100" />
    </div>
  );
};
const BlockName = ({ title, children }) => {
  return (
    <div className="flex flex-col justify-between overflow-hidden text-left transition-shadow duration-200 bg-white rounded shadow-xl group hover:shadow-2xl">
      <div className="p-5">
        <p className="mb-2 text-sm font-medium border-b pb-1.5">{title}</p>
        <p className="text-sm leading-5 text-gray-900">{children}</p>
      </div>
      <div className="w-full h-1 ml-auto duration-300 origin-left transform scale-x-0 bg-deep-purple-accent-400 group-hover:scale-x-100" />
    </div>
  );
};

const Status = ({ isOpen, onClick }) => {
  return (
    <>
      {isOpen ? (
        <span
          onClick={onClick}
          className="text-gray-400 bg-gray-200 rounded-full"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M18 12H6"
            />
          </svg>
        </span>
      ) : (
        <span
          onClick={onClick}
          className="text-white bg-yellowgray rounded-full"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
            />
          </svg>
        </span>
      )}
    </>
  );
};

const links = ["https://www.rungispianopiano-festival.com"];

function ReadWork() {
  const { user } = useAuth();

  let params = useParams();

  const [data, setData] = useState({}),
    [isOpen, setIsOpen] = useState(1),
    [openEditOeuvreModal, setOpenEditOeuvreModal] = useState(false);

  const getWorks = (id) => {
    axios
      .get(`/show-oeuvre/${id}`)
      .then((res) => {
        setData(res.data.data);
        const work = res?.data?.data;
        // ReactGA.initialize('G-NZMSS8WJ6K'); // add your tracking id here.

        // ReactGA.pageview(window.location.pathname,
        //     [''], "title");
        setTimeout(() => {
          if (window.gtag && work?.title) {
            console.log("window.gtag :>> ", window.gtag);
            window.gtag("event", "screen_view", {
              work_title: work?.title,
              // date: moment(new Date()).format("DD-MM-YYYY HH:mm:ss")
            });
          }
        }, 2000);
      })
      .catch(() => {});
  };

  useEffect(() => {
    getWorks(params?.id);
  }, []);

  const handleUpdateWork = () => {
    const url = getCurrentURL();

    if (!user) {
      window.location.pathname = `/oppdb/auth/login/?url=${url}`;
    } else {
      setOpenEditOeuvreModal(true);
    }
  };

  const handleSetIsOpen = (id) => {
    if (isOpen === id) {
      setIsOpen(0);
    } else {
      setIsOpen(id);
    }
  };

  function seoTitle() {
    if (!data || Object.keys(data).length === 0) return "Oppdb - work details";
    const { title, cpm_firstName, cpm_lastName, instrument } = data;
    let result = `Oppdb - ${title}`;
    // composer
    if (cpm_firstName || cpm_lastName) result += ` | Work By `;
    if (cpm_firstName) result += `${cpm_firstName} `;
    if (cpm_lastName) result += `${cpm_lastName} `;
    result += ` |  piano-piano.org `;

    return result;
  }
  function seoDescription() {
    // if (!data) return 'Oppdb work details'
    // const { title = '', cpm_firstName = '', cpm_lastName = '', instrument = '' } = data
    // const description = `${title},  a Work by ${cpm_firstName} ${cpm_lastName}, the instrument is ${instrument}`
    let description = seoTitle().split("|").join(",");
    return description;
  }
  return (
    <Layout>
      {data && data.title && (
        <SEO
          title={seoTitle()}
          description={seoDescription()}
          // name='Oppdb'
          type="Article"
        />
      )}

      <EditOeuvreModal
        open={openEditOeuvreModal}
        setOpen={setOpenEditOeuvreModal}
        oeuvreToEdit={data}
        onClose={() => setOpenEditOeuvreModal(false)}
      ></EditOeuvreModal>

      <section className="bg-white dark:bg-gray-900">
        <div className="w-full px-2 md:px-10 lg:px-24 2xl:px-32 py-10 mx-auto">
          <h1 className="text-xl md:text-4xl font-semibold text-center text-gray-800 dark:text-white">
            {data?.title}
          </h1>

          <div className="flex justify-between items-center w-full">
            <div className="my-8 flex justify-start space-x-4">
              <a
                onClick={() => window.close()}
                className="font-bold text-indigo-600 hover:text-pblue"
                title="Go back"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-6 h-6"
                >
                  <path
                    fillRule="evenodd"
                    d="M7.28 7.72a.75.75 0 010 1.06l-2.47 2.47H21a.75.75 0 010 1.5H4.81l2.47 2.47a.75.75 0 11-1.06 1.06l-3.75-3.75a.75.75 0 010-1.06l3.75-3.75a.75.75 0 011.06 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </a>
            </div>

            <div className="hidden my-8 md:flex justify-start md:justify-end space-x-4">
              <button
                onClick={() => handleUpdateWork()}
                className="whitespace-nowrap px-3 py-1.5 border border-pblue hover:-translate-y-1 hover:scale-110 text-pblue hover:text-white hover:bg-pblue text-sm font-medium border-white text-white"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="inline w-5 mb-1 h-5 mr-1"
                >
                  <path d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32l8.4-8.4z" />
                  <path d="M5.25 5.25a3 3 0 00-3 3v10.5a3 3 0 003 3h10.5a3 3 0 003-3V13.5a.75.75 0 00-1.5 0v5.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V8.25a1.5 1.5 0 011.5-1.5h5.25a.75.75 0 000-1.5H5.25z" />
                </svg>
                Update this card
              </button>
            </div>
          </div>

          <div className="mt-0 space-y-8">
            <div className="border-2 border-gray-100 rounded-lg dark:border-gray-700 shadow-md hover:shadow-xl">
              <button
                onClick={() => handleSetIsOpen(1)}
                className="flex items-center justify-between w-full p-8"
              >
                <h1 className="font-semibold text-gray-700 dark:text-white">
                  WORK INFORMATION
                </h1>

                <Status
                  onClick={() => handleSetIsOpen(1)}
                  isOpen={isOpen == 1 ? true : false}
                />
              </button>

              <hr className="border-gray-200 dark:border-gray-700" />

              <div
                id="block_1"
                className={`${
                  isOpen == 1 ? "  animate-fade-in-down block " : "  hidden "
                }${" relative grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 2xl:grid-cols-1 sm:grid-cols-2 md:grid-cols-3 2xl:grid-cols-4 p-4 bg-gray-100"}`}
              >
                <Block title={"Title"} content={data?.title} />
                <Block title={"Type of card"} content={data?.typeOfCard} />
                <Block title={"Type"} content={data?.typeChoosen} />
                <Block title={"Level"} content={data?.level} />
                <Block
                  title={"Date of publication"}
                  content={data?.dateOfPublication}
                />
                <Block
                  title={"Date of Composition"}
                  content={data?.dateOfComposition}
                />
                <Block title={"Content"} content={data?.mouvement} />
                {data?.instrument && (
                  <Block title={"Instrument"} content={data?.instrument} />
                )}
                <Block title={"Duration "} content={data?.duration} />
              </div>
            </div>

            <div className="border-2 border-gray-100 rounded-lg dark:border-gray-700 shadow-md hover:shadow-xl">
              <button
                onClick={() => handleSetIsOpen(2)}
                className="flex items-center justify-between w-full p-8"
              >
                <h1 className="font-semibold text-gray-700 dark:text-white uppercase">
                  COMPOSER{" "}
                </h1>

                <Status
                  onClick={() => handleSetIsOpen(2)}
                  isOpen={isOpen == 2 ? true : false}
                />
              </button>

              <hr className="border-gray-200 dark:border-gray-700" />

              <div
                id="block_2"
                className={`${
                  isOpen == 2
                    ? " transition duration-500 ease-in-out block "
                    : " hidden "
                }${" relative grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 2xl:grid-cols-4 p-4 bg-gray-100"}`}
              >
                <BlockName title={"Composer name"}>
                  {data?.cpm_firstName} {data?.cpm_lastName}
                </BlockName>
                <Block title={"Arranger name"} content={data?.arrangeurName} />
                <Block
                  title={"Original or transcription"}
                  content={data?.originalTranscription}
                />
                <Block
                  title={"Transcriptor name"}
                  content={data?.transcriptorName}
                />
                <Block title={"Publisher"} content={data?.publisher} />
                <Block
                  title={"Publisher reference"}
                  content={data?.publisherRef}
                />
              </div>
            </div>

            <div className="border-2 border-gray-100 rounded-lg dark:border-gray-700 shadow-md hover:shadow-xl">
              <button
                onClick={() => handleSetIsOpen(3)}
                className="animate-shine flex items-center justify-between w-full p-8"
              >
                <h1 className="font-semibold text-gray-700 dark:text-white">
                  ABOUT LINKS{" "}
                </h1>

                <Status
                  onClick={() => handleSetIsOpen(3)}
                  isOpen={isOpen == 3 ? true : false}
                />
              </button>

              <hr className="border-gray-200 dark:border-gray-700" />

              <div
                id="block_3"
                className={`${
                  isOpen == 3 ? " block " : " hidden "
                }${" relative grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 2xl:grid-cols-4 p-4 bg-gray-100"}`}
              >
                <BlockLink
                  title={"Link to score "}
                  content={data?.linkToScores}
                />
                <BlockLink title={"Link to hear"} content={data?.linkToHears} />
                <BlockLink title={"Link to CD "} content={data?.linkToBuys} />
                {data?.perfomedAtRppf === 1 && (
                  <BlockLink title={"Rungis festival link"} content={links} />
                )}
                {/* {data?.perfomedAtRppf==1&&<BlockLink title={"Performed at RPPF"} content={data?.rungisFestivallinks} />} */}
              </div>
            </div>

            <div className="border-2 border-gray-100 rounded-lg dark:border-gray-700 shadow-md hover:shadow-xl">
              <button
                onClick={() => handleSetIsOpen(4)}
                className="flex items-center justify-between w-full p-8"
              >
                <h1 className="font-semibold text-gray-700 dark:text-white">
                  OTHERS INFORMATIONS
                </h1>

                <Status
                  onClick={() => handleSetIsOpen(4)}
                  isOpen={isOpen == 4 ? true : false}
                />
              </button>

              <hr className="border-gray-200 dark:border-gray-700" />

              <div
                id="block_4"
                className={`${
                  isOpen == 4 ? " block " : " hidden "
                }${" relative grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 2xl:grid-cols-4 p-4 bg-gray-100"}`}
              >
                <Block
                  title={"First performance"}
                  content={data?.firstPerformance}
                />
                <Block title={"Nomenclature"} content={data?.nomenclature} />
                {/* <Block title={"Content"} content={data?.content} /> */}
                <Block title={"Notes"} content={data?.notes} />
              </div>
            </div>
          </div>

          <div className="my-8 flex justify-start md:justify-end space-x-4">
            <button
              onClick={() => handleUpdateWork()}
              className="whitespace-nowrap px-4 py-1.5 bg-pblue text-sm font-medium border-white text-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="inline w-5 mb-1 h-5 mr-1"
              >
                <path d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-8.4 8.4a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32l8.4-8.4z" />
                <path d="M5.25 5.25a3 3 0 00-3 3v10.5a3 3 0 003 3h10.5a3 3 0 003-3V13.5a.75.75 0 00-1.5 0v5.25a1.5 1.5 0 01-1.5 1.5H5.25a1.5 1.5 0 01-1.5-1.5V8.25a1.5 1.5 0 011.5-1.5h5.25a.75.75 0 000-1.5H5.25z" />
              </svg>
              Update this card
            </button>
          </div>
        </div>
      </section>
    </Layout>
  );
}

export default ReadWork;
